import styled from 'styled-components';

export const Content = styled.div`
  padding: 24px;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;

export const TextWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
